import emailValidation from './emailValidation.es';

export default {
  ...emailValidation,
};
